import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Column } from "@ant-design/charts";
import { useTranslation } from "react-i18next";
import { DatePicker, Select, Table } from "antd";
import { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import moment from "moment";
import { RangePickerProps } from "antd/lib/date-picker";
import { Card } from "../../../components/ui";
import api from "../../../services/api";
import { useToast } from "../../../hooks/toast";

import "./styles.less";
import { IUser } from "../../Users";
import { IOpexs } from "../index";

const { RangePicker } = DatePicker;

interface IStat {
  month: string;
  estimated: number;
  wasted: number;
}

interface IOpex {
  id: string;
  planned_opex: number;
  realized_opex: number;
  trimester: number;
  year: number;
  create_at: string;
  create_date: string;
}

interface IParms {
  update: any;
}

const ConsultantsProductivityStats: React.FC<IParms> = ({ update }) => {
  const { t } = useTranslation(["config"]);

  const [loading, setLoading] = useState(false);
  const [startMonth, setStartMonth] = useState("01-2023");
  const [endMonth, setEndMonth] = useState("04-2023");
  const [users, setUsers] = useState<IUser[]>([]);
  const [userFilter, setUserFilter] = useState(undefined);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [dateFilter, setDateFilter] = useState<IOpex[]>([]);
  const [opexs, setOpexs] = useState<IOpex[]>([]);

  const { addToast } = useToast();

  useEffect(() => {
    setLoading(true);
    api
      .get<IOpexs[]>("/opexs", {
        params: {
          name: undefined,
        },
      })
      .then((response) => {
        setDateFilter(response.data);
        setOpexs(response.data);
      })
      .catch((err) => {
        addToast({
          type: "error",
          title: "Erro na busca",
          description:
            "Occoreu um erro ao buscar os consultores, tente novamente.",
        });
      })
      .finally(() => setLoading(false));
  }, [addToast, update]);

  useEffect(() => {
    setLoadingUsers(true);
    api
      .get<IUser[]>("/users")
      .then((response) => {
        setUsers(response.data);
      })
      .catch(() => {
        addToast({
          type: "error",
          title: "Erro na busca",
          description:
            "Occoreu um erro ao buscar os consultores, tente novamente.",
        });
      })
      .finally(() => setLoadingUsers(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pagination: TablePaginationConfig = useMemo(
    () => ({
      defaultCurrent: 1,
      total: dateFilter?.length,
      defaultPageSize: 10,
    }),
    [dateFilter]
  );

  const stats = useMemo(
    () =>
      dateFilter.flatMap(({ planned_opex, create_date, realized_opex }) => {
        const year = moment(create_date).format("YYYY");
        const date = { trimester: "" };
        const trimester = Number(moment(create_date).format("MM"));
        if (trimester <= 3) date.trimester = `Trimestre 1 - ${year}`;
        if (trimester > 3 && trimester <= 6)
          date.trimester = `Trimestre 2 - ${year}`;
        if (trimester > 6 && trimester <= 9)
          date.trimester = `Trimestre 3 - ${year}`;
        if (trimester > 9) date.trimester = `Trimestre 4 - ${year}`;
        return [
          {
            month: date.trimester,
            name: t("Planejado"),
            value: planned_opex,
          },
          {
            month: date.trimester,
            name: t("Realizado"),
            value: realized_opex,
          },
        ];
      }) || [],
    [dateFilter, t]
  );

  const config = {
    data: stats,
    title: "Test",
    isGroup: true,
    xField: "month",
    yField: "value",
    seriesField: "name",
    height: 250,
    color: ["#3389eb", "#f39016ff"],
  };

  const onChangeDates: RangePickerProps["onChange"] = (dates: any) => {
    const isDate = opexs.filter(
      (con) =>
        moment(con.create_date).isSameOrBefore(dates[1], "month") &&
        moment(con.create_date).isSameOrAfter(dates[0], "month")
    );

    setStartMonth(moment(dates[0]).format("MM-YYYY"));
    setEndMonth(moment(dates[1]).format("MM-YYYY"));

    setDateFilter(isDate);
  };

  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    // Can not select days before today and today
    return current && current > moment().endOf("month");
  };

  return (
    <Card
      loading={loading}
      style={{ margin: "8px 0" }}
      extra={
        <>
          <RangePicker
            onChange={onChangeDates}
            format="MMMM YYYY"
            disabledDate={disabledDate}
            picker="month"
            allowClear={false}
            value={[moment(startMonth, "MM-YYYY"), moment(endMonth, "MM-YYYY")]}
          />
        </>
      }
      title={t("opexs.productivity")}
    >
      {/* <Col lg={6} md={24} xl={6}> */}
      <Column {...config} />
      {/* </Col> */}
      {/* <Col lg={18} md={24} xl={18}> */}
      {/* <Table
        className="table-striped"
        style={{ marginTop: 20 }}
        scroll={{
          x: "max-content",
          // y: maxHeight,
        }}
        dataSource={opex || []}
        rowKey={(record) => record.id}
        columns={consultantsColumns}
        pagination={pagination}
        size="small"
      /> */}
      {/* </Col> */}
    </Card>
  );
};

export default ConsultantsProductivityStats;
